function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @copyright Copyright (c) 2020 Florian Steffens <flost-dev@mailbox.org>
 *
 * @author Florian Steffens <flost-dev@mailbox.org>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
import axios from '@nextcloud/axios';
import { generateUrl } from '@nextcloud/router';
export var PersonApi = /*#__PURE__*/function () {
  function PersonApi() {
    _classCallCheck(this, PersonApi);
  }

  _createClass(PersonApi, [{
    key: "url",
    value: function url(_url) {
      _url = "/apps/health/persons".concat(_url);
      return generateUrl(_url);
    }
  }, {
    key: "load",
    value: function load() {
      return axios.get(generateUrl('/apps/health/persons')).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "addPerson",
    value: function addPerson(name) {
      return axios.post(this.url(''), {
        name: name
      }).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "deletePerson",
    value: function deletePerson(personId) {
      return axios.delete(this.url("/".concat(personId))).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }, {
    key: "updateValue",
    value: function updateValue(personId, key, value) {
      return axios.put(this.url("/".concat(personId)), {
        key: key,
        value: '' + value
      }).then(function (response) {
        return Promise.resolve(response.data);
      }, function (err) {
        return Promise.reject(err);
      }).catch(function (err) {
        return Promise.reject(err);
      });
    }
  }]);

  return PersonApi;
}();